@tailwind base;
@tailwind components;
@tailwind utilities;

/* for portable text */
@layer base {
  h1 {
    @apply text-5xl font-black;
  }
  h2 {
    @apply text-4xl  font-bold;
  }
  h3 {
    @apply text-3xl font-bold;
  }
  h4 {
    @apply text-2xl font-bold;
  }
  h5 {
    @apply text-xl font-bold;
  }
  h6 {
    @apply text-lg font-bold;
  }
}
